import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AslibAuthGuard } from '@aslib/security';
import { HomeComponent } from './home/home.component';
import { AdmPagamentoComponent } from './pagamento/adm-pagamento/adm-pagamento.component';
import { AdmParametroComponent } from './pagamento/adm-pagamento/adm-parametro.component';
import { CargaDadosComponent } from './pagamento/carga-dados/carga-dados.component';
import { PedidoComponent } from './pagamento/pedido/pedido.component';
import { ProjetoComponent } from './controle-dados/projeto/projeto.component';
import { GrupoComponent } from './controle-dados/grupo/grupo.component';
import { EmpenhoComponent } from './pagamento/empenho/empenho.component';
import { ProcessadoComponent } from './pagamento/empenho/processado/processado.component';
import { NaoProcessadoComponent } from './pagamento/empenho/nao-processado/nao-processado.component';
import { ProcessadoLiqComponent } from './pagamento/liq-pagamento/liq/processado/processado-liq.component';
import { NaoProcessadoLiqComponent } from './pagamento/liq-pagamento/liq/nao-processado/nao-processado-liq.component';
import { LiqComponent } from './pagamento/liq-pagamento//liq/liq.component';
import { ProcessadoLiqEmpenhoComponent } from './pagamento/liq-pagamento/liq-empenho/processado/processado-liq-empenho.component';
import { NaoProcessadoLiqEmpenhoComponent } from './pagamento/liq-pagamento//liq-empenho/nao-processado/nao-processado-liq-empenho.component';
import { LiqEmpenhoComponent } from './pagamento//liq-pagamento/liq-empenho/liq-empenho.component';
import { LiqPagamentoComponent } from './pagamento/liq-pagamento/liq-pagamento.component';
import { LiqComplementoComponent } from './pagamento/liq-pagamento/liq-complemento/liq-complemento.component';
import { RelLiquidacaoComponent } from './pagamento/relatorios/rel-liquidacao/rel-liquidacao.component';
import { FiltroRelLiquidacaoComponent } from './pagamento/relatorios/filtro-rel-liquidacao/filtro-rel-liquidacao.component';

const faTasks = 'fa fa-tasks';
const txtNaoProcessado = 'Não processado';
const txtProcessado = 'Processado';

export const routes: Routes = [
  {
    path: '',
    canLoad: [AslibAuthGuard],
    canActivate: [AslibAuthGuard],
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AslibAuthGuard],
    canLoad: [AslibAuthGuard],
    data: {
      aslib: {
        menu: {
          aslibIcon: { type: 1, icon: 'fa fa-home' },
          text: 'Home',
          menu: { hide: true }
        },
        ascas: { title: '[Página Inicial]' }
      }
    }
  },
  {
    path: 'pagamento',
    canActivate: [AslibAuthGuard],
    canLoad: [AslibAuthGuard],
    data: {
      aslib: {
        display: { menu: true },
        menu: {
          aslibIcon: { type: 1, icon: 'fa fa-money' },
          text: 'Geração de Pagamento',
          hide: false
        }
      },
      ascas: { title: '[Geração de Pagamento]' }
    },
    children: [
      {
        path: 'dados',
        component: CargaDadosComponent,
        canActivate: [AslibAuthGuard],
        canLoad: [AslibAuthGuard],
        data: {
          aslib: {
            display: { menu: true },
            menu: {
              aslibIcon: { type: 1, icon: 'fa fas fa-table' },
              text: 'Carga de dados',
              hide: false
            }
          },
          ascas: { title: '[Pagamento] Carga de dados' }
        }
      },
      {
        path: 'ped',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        canActivateChild: [AslibAuthGuard],
        component: PedidoComponent,
        data: {
          aslib: {
            menu: {
              aslibIcon: { type: 1, icon: faTasks },
              text: 'PED - Pedido de Empenho',
              hide: false
            }
          },
          ascas: { title: '[Pagamento] PED', isAscas: true }
        }
      },
      {
        path: 'emp',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        canActivateChild: [AslibAuthGuard],
        component: EmpenhoComponent,
        data: {
          aslib: {
            menu: {
              aslibIcon: { type: 1, icon: faTasks },
              text: 'EMP - Empenho',
              hide: false
            }
          },
          ascas: { title: '[Pagamento] EMP', isAscas: true }
        },
        children: [
          { path: '', redirectTo: 'processado', pathMatch: 'full' },
          {
            path: 'processado', component: ProcessadoComponent,
            data: {
              aslib: {
                display: { menu: true },
                menu: {
                  aslibIcon: { type: 1, icon: faTasks },
                  text: txtProcessado,
                  hide: true
                }
              }
              , ascas: { title: '[Pagamento] EMP - Processado PED' }
            }
          },
          {
            path: 'nao_processado', component: NaoProcessadoComponent,
            data: {
              aslib: {
                display: { menu: true },
                menu: {
                  aslibIcon: { type: 1, icon: faTasks },
                  text: 'Não processado',
                  hide: true
                }
              }
              , ascas: { title: '[Pagamento] EMP - Não Processado PED' }
            }
          },
        ]
      },
      {
        path: 'liq_pagamento',
        /**
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        canActivateChild: [AslibAuthGuard], 
        */
        component: LiqPagamentoComponent,
        data: {
          aslib: {
            menu: {
              aslibIcon: { type: 1, icon: faTasks },
              text: 'LIQ - Liquidação',
              hide: false
            }
          },
          ascas: { title: '[Pagamento] LIQ', isAscas: true }
        },
        children: [
          { path: '', redirectTo: 'liq_empenho', pathMatch: 'full' },
          {
            path: 'liq_empenho',
            /** 
            canLoad: [AslibAuthGuard],
            canActivate: [AslibAuthGuard],
            canActivateChild: [AslibAuthGuard], 
            */
            component: LiqEmpenhoComponent,
            data: {
              aslib: {
                menu: {
                  aslibIcon: { type: 1, icon: faTasks },
                  text: 'Geração',
                  hide: true
                }
              },
              ascas: { title: '[Pagamento] LIQ - Geração de liquidação', isAscas: true }
            },
            children: [
              { path: '', redirectTo: 'processado_liq_emp', pathMatch: 'full' },
              {
                path: 'processado_liq_emp',
                // canLoad: [AslibAuthGuard],
                // canActivate: [AslibAuthGuard],
                // canActivateChild: [AslibAuthGuard],          
                component: ProcessadoLiqEmpenhoComponent,
                data: {
                  aslib: {
                    display: { menu: true },
                    menu: {
                      aslibIcon: { type: 1, icon: faTasks },
                      text: txtProcessado,
                      hide: true
                    }
                  }
                  , ascas: { title: '[Pagamento] LIQ - Lista de EMPs processados' }
                },
                children: [
                  { path: '', redirectTo: 'processado_liq', pathMatch: 'full' },
                  {
                    path: 'liq_complemento',        
                    component: LiqComplementoComponent,
                    data: {
                      aslib: {
                        display: { menu: true },
                        menu: {
                          aslibIcon: { type: 1, icon: faTasks },
                          text: 'Dados complementares',
                          hide: true
                        }
                      }
                      , ascas: { title: '[Pagamento] LIQ - Dados complementares - Genérico' }
                    },
                  }
                ]
              },
              {
                path: 'nao_processado_liq_emp',
                // canLoad: [AslibAuthGuard],
                // canActivate: [AslibAuthGuard],
                // canActivateChild: [AslibAuthGuard],
                component: NaoProcessadoLiqEmpenhoComponent,
                data: {
                  aslib: {
                    display: { menu: true },
                    menu: {
                      aslibIcon: { type: 1, icon: faTasks },
                      text: txtNaoProcessado,
                      hide: true
                    }
                  }
                  , ascas: { title: '[Pagamento] LIQ - Lista de EMPs não processados' }
                }
              },
            ]
          },
          {
            path: 'liq',
            // canLoad: [AslibAuthGuard],
            // canActivate: [AslibAuthGuard],
            // canActivateChild: [AslibAuthGuard], 
            component: LiqComponent,
            data: {
              aslib: {
                menu: {
                  aslibIcon: { type: 1, icon: faTasks },
                  text: 'Resumo',
                  hide: true
                }
              },
              ascas: { title: '[Pagamento] LIQ', isAscas: true }
            },
            children: [
              { path: '', redirectTo: 'processado_liq', pathMatch: 'full' },
              {
                path: 'processado_liq',
                // canLoad: [AslibAuthGuard],
                // canActivate: [AslibAuthGuard],
                // canActivateChild: [AslibAuthGuard],
                component: ProcessadoLiqComponent,
                data: {
                  aslib: {
                    display: { menu: true },
                    menu: {
                      aslibIcon: { type: 1, icon: faTasks },
                      text: txtProcessado,
                      hide: true
                    }
                  }
                  , ascas: { title: '[Pagamento] LIQ - Lista de LIQs processadas' }
                }
              },

              {
                path: 'nao_processado_liq',
                // canLoad: [AslibAuthGuard],
                // canActivate: [AslibAuthGuard],
                // canActivateChild: [AslibAuthGuard], 
                component: NaoProcessadoLiqComponent,
                data: {
                  aslib: {
                    display: { menu: true },
                    menu: {
                      aslibIcon: { type: 1, icon: faTasks },
                      text: txtNaoProcessado,
                      hide: true
                    }
                  }
                  , ascas: { title: '[Pagamento] LIQ - Lista de LIQs não processadas' }
                }
              },
            ]
          }
        ]
      },
      {
        path: 'relatorios',
            canActivate: [AslibAuthGuard],
            canLoad: [AslibAuthGuard],
            data: {
              aslib: {
                display: { menu: true },
                menu: {
                  aslibIcon: { type: 1, icon: 'fa fa-print' },
                  text: 'Relatórios',
                  hide: false
                }
              },
              ascas: { title: '[Relatórios]' }
            },
            children: [
              {
                path: 'rel-liquidacao',
                component: RelLiquidacaoComponent,
                canActivate: [AslibAuthGuard],
                canLoad: [AslibAuthGuard],
                data: {
                  aslib: {
                    display: { menu: true },
                    menu: {
                      aslibIcon: { type: 1, icon: 'fa fa-file-text-o' },
                      text: 'Relatório de Liquidação',
                      hide: false
                    }
                  },
                  ascas: { title: '[Pagamento] Relatório de Liquidação' }
                }
              }
            ]
        }
    ]
  },
  {
    path: 'parametros',
    canActivate: [AslibAuthGuard],
    canLoad: [AslibAuthGuard],
    data: {
      aslib: {
        display: { menu: true },
        menu: {
          aslibIcon: { type: 1, icon: 'fa fa-money' },
          text: 'Parâmetros',
          hide: false
        }
      },
      ascas: { title: '[Parametros]' }
    },
    children:[
      {
        path: 'param-pagamento',
        component: AdmPagamentoComponent,
        canActivate: [AslibAuthGuard],
        canLoad: [AslibAuthGuard],
        data: {
          aslib: {
            display: { menu: true },
            menu: {
              aslibIcon: { type: 1, icon: 'fa fa-cubes' },
              text: 'Parâmetros geração de pagamento',
              hide: false
            }
          },
          ascas: { title: '[Parametros] Parâmetros para geração de pagamentos' }
        }
      },
      {
        path: 'param-notificacao',
        component: AdmParametroComponent,
        canActivate: [AslibAuthGuard],
        canLoad: [AslibAuthGuard],
        data: {
          aslib: {
            display: { menu: true },
            menu: {
              aslibIcon: { type: 1, icon: 'fa fa-cubes' },
              text: 'Parâmetros serviço notificação por e-mail',
              hide: false
            }
          },
          ascas: { title: '[Parametros] Parâmetros Notificação' }
        }
      },
    ]
  },
  {
    path: 'dados',
    canActivate: [AslibAuthGuard],
    canLoad: [AslibAuthGuard],
    data: {
      aslib: {
        display: { menu: true },
        menu: {
          aslibIcon: { type: 1, icon: 'fa fa-money' },
          text: 'Controle de Dados',
          hide: false
        }
      },
      ascas: { title: '[Controle de Dados]' }
    },
    children: [
      {
        path: 'projeto',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        canActivateChild: [AslibAuthGuard],
        component: ProjetoComponent,
        data: {
          aslib: {
            menu: {
              aslibIcon: { type: 1, icon: faTasks },
              text: 'Projetos',
              hide: false
            }
          },
          ascas: { title: '[Controle de Dados] Projetos', isAscas: true }
        }
      },
      {
        path: 'grupo',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        canActivateChild: [AslibAuthGuard],
        component: GrupoComponent,
        data: {
          aslib: {
            menu: {
              aslibIcon: { type: 1, icon: faTasks },
              text: 'Grupos',
              hide: false
            }
          },
          ascas: { title: '[Controle de Dados] Grupos', isAscas: true }
        }
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts